import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/miejsce/:title-:id",
    name: "Article",
    component: () => import("../components/article/article.vue"),
  },
  {
    path: "/miejsce/:title",
    beforeEnter: (to, from, next) => {
      const title = to.params.title;
      Vue.http.get("random/", { params: { title: title } }).then((response) => {
        next({
          name: "Article",
          params: { id: response.data.id, title: title },
        });
      });
    },
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      Vue.http.get("random/").then((response) => {
        next({
          name: "Article",
          params: { id: response.data.id, title: response.data.title },
        });
      });
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
